<template>
  <div>
    <div>
      <div class="d-flex align-center mb-5">
        <router-link :to="{name: 'storeProfileInfo'}" class="router-link">
          <v-icon color="grey darken-1" class="mr-3" size="32">mdi-arrow-left-circle</v-icon>
        </router-link>
        <h3 class="mb-0">Account</h3>
      </div>
      <v-card>
        <div class="pa-5">
          <v-row>
            <v-col cols="12">

              <v-img cover class="br-8" height="173" :src="imgPreview.banner">
                <div class="d-inline-flex p-absolute right-0 ma-5">
                  <label for="cover-upload-banner">
                    <span
                        class="primary cursor-pointer lighten-5 pa-1 d-flex rounded-circle">
                      <img v-svg-inline class="icon primary--text"
                           src="@/assets/icons/camera.svg" alt=""/>
                    </span>
                  </label>
                  <input type="file" id="cover-upload-banner" class="d-none" @change="onBannerImgUpload"/>
                </div>

                <div class="d-inline-flex p-absolute bottom-0 ma-5">
                  <v-avatar size="80">
                    <img :src="imgPreview.logo" alt="">
                  </v-avatar>
                  <div class="d-inline-flex p-absolute right-0 bottom-0">
                    <label for="cover-upload-avatar">
                      <span
                          class="grey lighten-2 cursor-pointer lighten-5 pa-1 d-flex rounded-circle">
                        <img v-svg-inline class="icon secondary--text"
                             src="@/assets/icons/camera.svg" alt=""/>
                      </span>
                    </label>
                    <input type="file" id="cover-upload-avatar" class="d-none" @change="onLogoImgUpload"/>
                  </div>
                </div>
              </v-img>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Store Name *</p>
              <v-text-field
                  outlined
                  dense
                  class="py-0 mt-0"
                  placeholder="Decentral Store"
                  v-model="storeProfile.name"
                  :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Youtube</p>
              <v-text-field
                  outlined
                  dense
                  placeholder="Youtube URL"
                  v-model="storeProfile.mediaURL.youtube"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Instagram</p>
              <v-text-field
                  outlined
                  dense
                  placeholder="Instagram URL"
                  v-model="storeProfile.mediaURL.instagram"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Facebook</p>
              <v-text-field
                  outlined
                  dense
                  placeholder="Instagram URL"
                  v-model="storeProfile.mediaURL.facebook"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Discord</p>
              <v-text-field
                  outlined
                  dense
                  placeholder="Discord URL"
                  v-model="storeProfile.mediaURL.discord"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Twitter</p>
              <v-text-field
                  outlined
                  dense
                  placeholder="Twitter URL"
                  v-model="storeProfile.mediaURL.twitter"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Website</p>
              <v-text-field
                  outlined
                  dense
                  placeholder="URL"
                  v-model="storeProfile.mediaURL.website"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Telephone</p>
              <v-text-field
                  outlined
                  dense
                  placeholder="+852 22113355"
                  v-model="storeProfile.contact.phoneNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="text-14 mb-1">Email</p>
              <v-text-field
                  outlined
                  dense
                  placeholder="shopmail@email.com"
                  v-model="storeProfile.contact.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <p class="text-14 mb-1">Store Summary *</p>
              <v-textarea
                  outlined
                  v-model="storeProfile.summary"
                  :rules="[rules.required]"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <p class="text-14 mb-1">Store Description *</p>
              <v-textarea outlined v-model="storeProfile.description" :rules="[rules.required]"></v-textarea>
            </v-col>
          </v-row>
          <div class="text-end">
            <v-btn color="indigo darken-2" dark @click="onSubmitHandle">Submit</v-btn>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import backendCall from "@/lib/backendCall/index";
import store from "@/store";
import Vue from 'vue'

const defaultBanner = require("@/assets/images/storeDefaultBanner.png")
const defaultLogo = require("@/assets/images/decentralStoreLogo.png")
import helper from "@/lib/helper/index"


export default {
  components: {},
  data() {
    return {
      imgPreview: {
        logo: "", //base64
        banner: "" //base64
      },
      storeProfile: {
        name: "",
        mediaURL: {
          youtube: "",
          instagram: "",
          facebook: "",
          discord:"",
          twitter: "",
          website: "",
        },
        contact: {
          phoneNumber: "",
          email: "",
        },
        summary: "",
        description: "",
      },
      imgFiles: {
        logo: null,
        banner: null
      },
      rules: {
        required: value => !!value || 'Required.',
      }
    }
  },
  mounted() {
    this.fetchStoreProfileData()
  },
  methods: {
    async fetchStoreProfileData() {
      try {
        const res = await backendCall.store.getStoreProfile(store.state.loggedInAccount)
        if (res.status === 0) {
          throw Error(res.message)
        }

        if (res.status === 1) {
          let profile = res.data
          if (profile) {
            this.storeProfile = {
              name: profile.name,
              mediaURL: profile.mediaURL,
              contact: profile.contact,
              summary: profile.summary,
              description: profile.description
            }
            this.imgPreview.logo = profile.logoURL
            this.imgPreview.banner = profile.bannerURL
          }
        }

        //handle for the case logo or banner not being set
        if (this.imgPreview.logo === ""){
          this.imgPreview.logo = defaultLogo
        }

        if (this.imgPreview.banner === ""){
          this.imgPreview.banner = defaultBanner
        }
      }catch (e) {
        console.error(e)
        Vue.notify({
          type: "error",
          text: e.message
        })
      }
    },
    async onBannerImgUpload(e) {
      const selectedFile = e.target.files[0];
      console.log(selectedFile)
      this.imgPreview.banner = await helper.image.imgFileToBase64(selectedFile)
      this.imgFiles.banner = selectedFile
    },

    async onLogoImgUpload(e) {
      const selectedFile = e.target.files[0];
      this.imgPreview.logo = await helper.image.imgFileToBase64(selectedFile)
      this.imgFiles.logo = selectedFile
    },
    async onSubmitHandle(){
      let formData = new FormData();
      formData.append('profileData', JSON.stringify(this.storeProfile));
      formData.append('logo', this.imgFiles.logo);
      formData.append('banner', this.imgFiles.banner);
      try {
        const res = await backendCall.store.updateStoreProfile(formData);
        if (res.status === 1){
          store.commit('setStoreProfile', res.data)
          Vue.notify({type: 'success', text: res.message})
          await this.$router.push({name: 'storeProfileInfo'})
        }
        if (res.status === 0){
          Vue.notify({type: 'error', text: res.message})
        }
      }catch (e) {
        console.error(e.message)
      }
    }
  }
}
</script>